import axios from 'axios';
import { Message } from 'element-ui';

const REQ_RETRY = 5; // 请求重试次数
const REQ_DELAY = 1000; // 请求重试间隔ms
const TIMEOUT = 120000; // 请求超时时间ms

// 创建实例
axios.defaults.isSetAuth = false; // 是否设置授权信息
export const Axios = axios.create({
    timeout: TIMEOUT,
    retry: REQ_RETRY, // 未实现
    retryDelay: REQ_DELAY, // 未实现
    headers: {}
});

// 设置全局授权请求头
export const setAuth = token => {
    const headers = Axios.defaults.headers;
    Axios.defaults.headers = headers;
};

// 请求拦截
Axios.interceptors.request.use(
    request => {
        request.headers.Authorization = Axios.defaults.headers.Authorization;
        return request;
    },
    error => {
        return Promise.reject(error);
    }
);

// 响应拦截
Axios.interceptors.response.use(
    response => {
        const code = response.data.code;
        if (code === 400) {
            // 请求失败
            return Promise.reject(response);
        } else if (code === 401) {
            // 未登录或登录超时
            return Promise.reject(response);
        }
        return response;
    },
    error => {
        if (typeof error.response.data === 'string') {
            if (error.response.data.length > 0) {
                if (error.response.data[0] === '{') {
                    error.response.data = JSON.parse(error.response.data);
                } else {
                    // 新增AES解密
                    const key = CryptoJS.enc.Utf8.parse('Ds3o00ra43ym9X8s');
                    const bytes = CryptoJS.AES.decrypt(error.response.data, key, {
                        mode: CryptoJS.mode.ECB,
                        padding: CryptoJS.pad.Pkcs7
                    });
                    const outputStr = bytes.toString(CryptoJS.enc.Utf8);
                    const output = JSON.parse(outputStr);
                    error.response.data = output;
                }
            }
        }
        const code = error.response.status;
        if (code !== 200) {
            // 请求异常
            Message.error(error.response.data.msg || code);
        }
        if (code === 400) {
            // 请求失败
            return Promise.reject(error);
        } else if (code === 401) {
            // 未登录或登录超时

            return Promise.reject(error);
        }
        return Promise.reject(error);
    }
);
